/* istanbul ignore file */
import React from 'react';
import { Dropdown, DefaultDropdownProps } from 'framework/form';
import { LEAD_STATUS } from 'domain/sales/lead/shared/leadService';

const LeadStatusDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return (
    <Dropdown
      placeholder="Choose lead status"
      options={Object.entries(LEAD_STATUS).map(entry => {
        const [value, label] = entry;
        return {
          value,
          label,
        };
      })}
      label="Lead status"
      {...props}
    />
  );
};

export default LeadStatusDropdown;
